import { useValidateEmailConfirmationCode } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"

interface Params {
  emailAddress: string;
  onSuccessCallback: (emailAddress: string, confirmationCode: string) => void;
}

export function useAutoValidateEmailConfirmationCode(params: Params) {
  const {
    emailAddress,
    onSuccessCallback,
  } = params

  const validateEmailConfirmationCode = useValidateEmailConfirmationCode()

  return useMemo(
    () => !validateEmailConfirmationCode
      ? undefined
      : async (code: string) => {
        // attempt to verify code as soon as user has input a potentially valid code
        try {
          await validateEmailConfirmationCode({
            email: emailAddress,
            code,
          })
          onSuccessCallback(
            emailAddress,
            code,
          )
        } catch {
          // fail silently because the user does not know we have taken an action
        }
      },
    [
      emailAddress,
      validateEmailConfirmationCode,
      onSuccessCallback,
    ],
  )
}
